import { render, staticRenderFns } from "./LabelTip.vue?vue&type=template&id=caeb2820&scoped=true"
import script from "./LabelTip.vue?vue&type=script&lang=js"
export * from "./LabelTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeb2820",
  null
  
)

export default component.exports